import { render, staticRenderFns } from "./EditLevelView.vue?vue&type=template&id=52e17e23&scoped=true&"
import script from "./EditLevelView.vue?vue&type=script&lang=ts&"
export * from "./EditLevelView.vue?vue&type=script&lang=ts&"
import style0 from "./EditLevelView.vue?vue&type=style&index=0&id=52e17e23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e17e23",
  null
  
)

export default component.exports